let srvName = '/opxp/'
const service = {
    // 订单保存
    payProcess: srvName + 'payReqProcess',
    //获取订单信息
    orderInfo: srvName + 'orderInfo',
    //获取随机数
    serverRandom: srvName + 'loginServerRandom',
    // 登录
    login: srvName + 'login',
    // 验证码
    captcha: srvName + 'verificationCode',
    // 网银
    ebank: {
        accounts: srvName + 'accounts',
        etoken: srvName + 'etoken'
    },
    // 支付
    payment: {
        confirm: srvName + 'confirmation',
        submit: srvName + 'orderPayment'
    },
    //发送失败AC报文
    opxpPayFailure: srvName + 'opxpPayFailure'
}
export default service;


// WEBPACK FOOTER //
// ./src/service/service.js